var HomeVideo = (function () {

    var vidWrapper, vid, vidRatio, pic, videoCont;

    var init = function () {
        return;
            vidWrapper = $('.push-video');
            if (!vidWrapper.length) return;
            vid = document.getElementById('home-video');
            pic = document.getElementById('home-picture');
            videoCont = $('.video-main')

            vidRatio = $(vid).attr('width') / $(vid).attr('height');

            $(window).on('resize', resize);
            resize();

            vid.oncanplay = function() {
                $('.push-video').removeClass('invisible');
                vid.oncanplay = null;
                startObserver();
            }

            $('.scroll-to-content').on('click', function(){
                $('html, body').animate({
                    scrollTop:$('.content-main').offset().top// - $('#top-header').height()
                }, 'slow');
                return false;
            });
        },
        startObserver = function () {
            var options = {}
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        vid.play()
                    } else {
                        vid.pause()

                    }
                });
            }, options);
            observer.observe(vidWrapper[0]);
        },
        resize = function () {
            var wh = videoCont.height(),
                ww = videoCont.width(),
                rw,
                avh;
            rw = ww / wh;
            if (rw < vidRatio) {
                $(vid).addClass('vertical');
                $(pic).addClass('vertical');
            } else {
                $(vid).removeClass('vertical');
                $(pic).removeClass('vertical');
            }

        };

    return {
        init: init,
    }

})();